export default {
  memberKey: 'type'
  nameKeys: [
    'name'
  ]

  groupings: []

  actionsPages: [
    {
      key: 'clear-space'
      title: 'Clear space'
      component: 'clear_space'
    }
    {
      key: 'upload-excel'
      title: 'Upload Excel'
      component: 'upload_file'
      service: { name: 'weaver-importer-exporter', call: 'import', staticArgs: ['raw-xl'], config: {wipe: false, memberKey: 'type'}  }
    }
    {
      key: 'upload-excel-path'
      title: 'Upload Excel Path'
      component: 'upload_file'
      service: { name: 'weaver-importer-exporter', call: 'import', staticArgs: ['excel-path'], config: {wipe: false, memberKey: 'type'}  }
    }
    {
      key: 'upload-csv'
      title: 'Upload CSV'
      component: 'upload_file'
      service: { name: 'weaver-importer-exporter', call: 'import', staticArgs: ['raw-csv'], config: {wipe: false, memberKey: 'type'}  }
    }
    {
      key: 'upload-xml'
      title: 'Upload XML'
      component: 'upload_file'
      service: { name: 'weaver-importer-exporter', call: 'import', staticArgs: ['raw-xml'], config: {wipe: false, memberKey: 'type'}  }
    }
    {
      key: 'upload-json'
      title: 'Upload JSON'
      component: 'upload_file'
      service: { name: 'weaver-importer-exporter', call: 'import', staticArgs: ['raw-json'], config: {wipe: false, memberKey: 'type'}  }
    }
    {
      key: 'upload-trig'
      title: 'Upload Trig'
      component: 'upload_file'
      service: { name: 'weaver-importer-exporter', call: 'import', staticArgs: ['trig'], config: {}  }
    }
    {
      key: 'upload-turtle'
      title: 'Upload Turtle'
      component: 'upload_file'
      service: { name: 'weaver-importer-exporter', call: 'import', staticArgs: ['turtle'], config: { wipe: false }  }
    }
    {
      key: 'upload-tabtriples'
      title: 'Upload SPARQL TSV'
      component: 'upload_file'
      service: { name: 'weaver-importer-exporter', call: 'import', staticArgs: ['tabtriples'], config: {wipe: false, delimiter: 'tab'}  }
    }
    {
      key: 'upload-yaml'
      title: 'Upload Weaver Model'
      component: 'upload_file'
      service: { name: 'weaver-importer-exporter', call: 'import', staticArgs: ['yaml-to-rdfs'], config: {wipe: false, memberKey: 'type'}  }
    }
    {
      key: 'upload_transformations_yaml_file'
      title: 'Upload Transform Script'
      component: 'upload_transformations_file'
      service: { name: 'weaver-transform', call: 'transformFromFile', config: {} }
    }
    {
      key: 'upload-relatics'
      title: 'Upload Relatics XML'
      component: 'upload_file'
      service: { name: 'weaver-importer-exporter', call: 'import', staticArgs: ['relatics-stream'], config: { wipe: false, memberKey: 'type' }  }
    }
    {
      key: 'upload-bim360'
      title: 'Upload BIM360 json'
      component: 'upload_file'
      service: { name: 'weaver-importer-exporter', call: 'import', staticArgs: ['bim360'], config: { wipe: false, memberKey: 'type' }  }
    }
    {
      key: 'generate-turtle'
      title: 'Generate Turtle'
      component: 'generate_file'
      service: {
        name: 'weaver-importer-exporter',
        call: 'export',
        staticArgs: ['turtle']
        config: { wipe: false, filename: 'export.ttl' }
        verb: 'export'
      }
    },
    {
      key: 'train-ml'
      title: 'Machine Learning - Start Training'
      component: 'train_ml'
      service: {
        name: 'pythia-connector',
        call: 'train'
      }
    }
    {
      key: 'status-ml'
      title: 'Machine Learning - Training Status'
      component: 'status_ml'
      service: {
        name: 'pythia-connector',
        call: 'getStatus'
      }
    }
    {
      key: 'predict-ml'
      title: 'Machine Learning - Predict'
      component: 'predict_ml'
      service: {
        name: 'pythia-connector',
        call: 'predict'
      }
    }
    {
      key: 'importUsers'
      title: 'Import Users'
      component: 'upload_file'
      service: {
        name: 'weaver-importer-exporter'
        call: 'import'
        staticArgs: ['create-weaver-users'],
        config: { wipe: false }
      }
    }
  ]

  queries: []
}
